<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-20 16:36:20
 * @LastEditTime: 2020-08-18 10:37:41
-->
<template>
  <Modal
    v-model="visible"
    width="600"
    title="项目方案"
    :mask-closable="false"
    @on-cancel="closeModal"
    class="project-alternatives">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="130">
      <div class="type">
        <FormItem label="选择类型：" prop="projectSchemeId">
          <Select
            v-model="formValidate.projectSchemeId"
            placeholder="请选择"
            style="width:150px"
            :disabled="true"
            class="typeParent">
            <Option
              v-for="item in cityList"
              :value="item.value"
              :key="item.value">
              {{item.label}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="选择类型：" prop="projectPrizeId">
          <Select
            v-model="formValidate.projectPrizeId"
            placeholder="请选择"
            :disabled="true"
            style="width:150px">
             <Option
              v-for="item in cityLists"
              :value="item.value"
              :key="item.value">
              {{item.label}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="项目方案名称：" prop="projectName">
          <Input v-model="formValidate.projectName" placeholder="请选择"></Input>
        </FormItem>
        <FormItem label="单位名称：" prop="organizationName">
          <Input v-model="formValidate.organizationName" placeholder="请选择" :maxlength="40"></Input>
        </FormItem>
        <FormItem label="项目方案摘要：" prop="projectBrief">
          <Input
            v-model="formValidate.projectBrief"
            maxlength="500"
            type="textarea"
            :autosize="{minRows: 3,maxRows: 7}"
            placeholder="请选择"
            show-word-limit></Input>
        </FormItem>
        <FormItem label="项目方案自评：" prop="projectEvaluate">
          <Input
            v-model="formValidate.projectEvaluate"
            type="textarea"
            maxlength="1200"
            :autosize="{minRows: 3,maxRows: 7}"
            placeholder="请选择"
            show-word-limit></Input>
        </FormItem>
        <FormItem label="案例措施：" prop="projectMeasures">
          <Input
            v-model="formValidate.projectMeasures"
            type="textarea"
            maxlength="1200"
            :autosize="{minRows: 3,maxRows: 7}"
            placeholder="请选择"
            show-word-limit></Input>
        </FormItem>
      </div>
    </Form>
    <div slot="footer">
      <Button type="primary" @click="goPublish('formValidate')">发布</Button>
    </div>
  </Modal>
</template>

<script>
import $bus from '@/utils/bus.js'
import { mapActions } from 'vuex'
export default {
  props: {
    show: { // 传回 控制modal显示
      type: Boolean,
      defalult: false,
    },
    title: {
      type: String,
      default: '',
    },
    cityLists: {
      type: Array,
      default: () => ([]),
    },
    cityList: {
      type: Array,
      default: () => ([]),
    },
    formValidates: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['yeye'],
  data() {
    return {
      visible: this.show,
      formValidate: {
        projectPrizeId: '',
        projectSchemeId: '',
        organizationName: '',
        projectName: '',
        projectBrief: '',
        projectEvaluate: '',
      },
      demo: this.yeye,
      ruleValidate: {
        projectPrizeId: [
          { required: true, message: '请选择类型' },
        ],
        projectSchemeId: [
          { required: true, message: '请选择类型' },
        ],
        organizationName: [
          { required: true, message: '请输入单位名称', trigger: 'blur,change' },
        ],
        projectName: [
          { required: true, message: '请输入项目方案名称', trigger: 'blur,change' },
          {
            // eslint-disable-next-line no-unused-vars
            validator: (rule, value, callback) => {
              const str = value.trim()
              const len = 80
              if (str) {
                if (str.length <= len) {
                  callback()
                } else {
                  callback(`项目方案名称最多输入${len}字`)
                }
              }
            },
            trigger: 'blur',
          },
        ],
        projectBrief: [
          { required: true, message: '请输入项目方案摘要', trigger: 'blur,change' },
        ],
        projectEvaluate: [
          { required: true, message: '请输入项目方案自评', trigger: 'blur,change' },
        ],
      },
    }
  },
  watch: {
    show(val) {
      this.visible = val
      this.formValidate.projectSchemeId = this.formValidates.projectSchemeId
      this.formValidate.projectPrizeId = this.formValidates.projectPrizeId
    },
    formValidates: {
      deep: true,
      handler(val) {
        this.formValidate = val
      },
    },
  },
  mounted() {},
  methods: {
    goPublish(name) {
      $bus.$on('showDialog', (changeOrg) => {
        console.log('yyyyyyyyyyyyyy-----------', changeOrg)
      })
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.submit()
        }
      })
    },
    async submit() {
      // let res = ''
      if (this.title === 'update') {
        await this.update(this.formValidate).then(res => {//eslint-disable-line
          if (res.code === '0' && res.flag === '0') {
            this.$Message.success('发布成功!')
            this.closeModal()
          }
        })
          .catch(err => {
            this.$Message.error(err.message)
          })
      } else {
        await this.save(this.formValidate).then(res => {//eslint-disable-line
          if (res.code === '0' && res.flag === '0') {
            this.$Message.success('发布成功!')
            this.closeModal()
          }
        })
          .catch(err => {
            this.$Message.error(err.message)
          })
      }
      // if (this.title === 'update') {
      //   try {
      //     const res = await this.update(this.formValidate)
      //     if (res.code === '0' && res.flag === '0') {
      //       this.$Message.success('发布成功!')
      //       this.closeModal()
      //     }
      //   } catch (error) {
      //     this.$Message.error(error.message)
      //   }
      // } else {
      //   try {
      //     const res =  await this.save(this.formValidate)
      //     if (res.code === '0' && res.flag === '0') {
      //       this.$Message.success('发布成功!')
      //       this.closeModal()
      //     }
      //   } catch (error) {
      //     this.$Message.error(error.message)
      //   }
      // }
      // console.log(res)
      // if (res.code === '0' && res.flag === '0') {
      //   this.$Message.success('发布成功!')
      //   this.closeModal()
      // } else {
      //   console.log(res)
      //   this.$Message.error(res.message)
      // }
    },
    closeModal() {
      this.$refs['formValidate'].resetFields()
      this.visible = false
      this.$emit('showModel', false)
    },
    ...mapActions({
      save: 'jurisprudenceDaily/projectManagement/save',
      update: 'jurisprudenceDaily/projectManagement/update',
    }),
  },
}
</script>

<style lang='scss' scoped>
.project-alternatives {
  .type {
    .typeParent {
      margin-right: 20px;
    }
    justify-content: space-between;
    /deep/.ivu-form-item-content {
      display: flex;
      // justify-content: space-around;
    }
  }
}
</style>